import styles from './_style.module.scss';
import buildIslandTheme from 'components/quote_builder_widget/shared/buildIslandTheme';

export default buildIslandTheme(styles, { maxWidth: 480, defaultHighlightColor: '#0f766e' });
